import React, { useEffect, useState } from "react";
import api, { API } from "../../lib/api";
import { ComuneSelect } from "../../components/ComuneSelect";
import { getProvinceCoperte } from "../../lib/istat";

const CRITERI = {
  preferenza_venditore: "Preferenza venditore",
  rotazione: "Rotazione",
  manuale: "Assegnazione manuale",
};

const fmtDT = (iso) => iso ? new Date(iso).toLocaleString("it-IT") : "—";

export default function RegistroRichieste() {
  const [rows, setRows] = useState([]);
  const [stats, setStats] = useState(null);
  const [agencies, setAgencies] = useState([]);
  const [province, setProvince] = useState([]);
  const [filters, setFilters] = useState({ provincia: "", comune: "", agency_id: "", criterio: "", from_date: "", to_date: "" });
  const [pdfModal, setPdfModal] = useState(false);
  const [pdfDest, setPdfDest] = useState("");
  const [pdfLoading, setPdfLoading] = useState(false);

  const load = async () => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => { if (v) params.set(k, v); });
    const r = await api.get(`/lead-assignments?${params.toString()}`);
    setRows(r.data);
  };
  const loadStats = () => api.get("/lead-assignments/stats").then((r) => setStats(r.data));

  useEffect(() => {
    api.get("/agencies").then((r) => setAgencies(r.data));
    getProvinceCoperte().then(setProvince);
    loadStats();
  }, []);
  useEffect(() => { load(); }, [filters]);

  const upd = (k) => (e) => setFilters({ ...filters, [k]: e.target.value });

  const exportCSV = () => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => { if (v && k !== "from_date" && k !== "to_date") params.set(k, v); });
    const token = localStorage.getItem("rxcasa_token");
    const url = `${API}/lead-assignments/export.csv?${params.toString()}`;
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "registro-richieste.csv";
        link.click();
      });
  };

  const resetFilters = () => setFilters({ provincia: "", comune: "", agency_id: "", criterio: "", from_date: "", to_date: "" });

  const exportPDF = async () => {
    if (!filters.provincia && !filters.comune) {
      alert("Seleziona almeno una provincia o un comune per generare il registro opponibile.");
      return;
    }
    setPdfLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.provincia) params.set("provincia", filters.provincia);
      if (filters.comune) params.set("comune", filters.comune);
      if (filters.from_date) params.set("from_date", filters.from_date);
      if (filters.to_date) params.set("to_date", filters.to_date);
      if (pdfDest) params.set("destinatario_agency_id", pdfDest);
      const token = localStorage.getItem("rxcasa_token");
      const res = await fetch(`${API}/lead-assignments/export.pdf?${params.toString()}`,
        { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) {
        const err = await res.json().catch(() => ({ detail: "Errore generazione PDF" }));
        alert(err.detail || "Errore generazione PDF");
        return;
      }
      const blob = await res.blob();
      const zone = (filters.comune || filters.provincia || "zona").toLowerCase().replace(/\s+/g, "-");
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `registro-${zone}.pdf`;
      link.click();
      setPdfModal(false);
      setPdfDest("");
    } finally {
      setPdfLoading(false);
    }
  };

  return (
    <div data-testid="registro-page">
      <div className="mb-8">
        <div className="label-uppercase">Tracciabilità & opponibilità</div>
        <h1 className="font-serif text-4xl mt-2">Registro Richieste</h1>
        <p className="text-sm text-[#5C5657] mt-2 max-w-2xl">
          Registro immutabile di tutti gli inoltri: ogni assegnazione salva data lead, comune/provincia, agenzia, criterio di assegnazione, data e ora dell'inoltro. I record non sono modificabili né eliminabili.
        </p>
      </div>

      {stats && (
        <div className="grid md:grid-cols-4 gap-4 mb-8">
          <div className="admin-card p-5">
            <div className="label-uppercase">Inoltri totali</div>
            <div className="font-serif text-4xl text-[#7D2E3F] mt-2">{stats.total}</div>
          </div>
          <div className="admin-card p-5">
            <div className="label-uppercase">Preferenza venditore</div>
            <div className="font-serif text-4xl mt-2">{stats.per_criterio?.preferenza_venditore || 0}</div>
          </div>
          <div className="admin-card p-5">
            <div className="label-uppercase">Rotazione</div>
            <div className="font-serif text-4xl mt-2">{stats.per_criterio?.rotazione || 0}</div>
          </div>
          <div className="admin-card p-5">
            <div className="label-uppercase">Manuale</div>
            <div className="font-serif text-4xl mt-2">{stats.per_criterio?.manuale || 0}</div>
          </div>
        </div>
      )}

      {stats?.per_zona?.length > 0 && (
        <div className="admin-card p-6 mb-8">
          <div className="label-uppercase mb-4">Storico per zona</div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2 text-sm">
            {stats.per_zona.slice(0, 30).map((z, i) => (
              <div key={i} className="flex justify-between border-b border-[#E6E4E0] py-2">
                <span className="text-[#3A3D42]">{z.comune || "—"} <span className="text-[#8A8484]">({z.provincia || "—"})</span></span>
                <span className="font-serif text-[#7D2E3F]">{z.count}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="admin-card p-6 mb-6">
        <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-4">
          <div>
            <label className="label-uppercase">Provincia</label>
            <select value={filters.provincia} onChange={(e) => setFilters({ ...filters, provincia: e.target.value, comune: "" })} className="admin-input" data-testid="filter-provincia">
              <option value="">Tutte</option>
              {province.map((p) => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>
          <div>
            <label className="label-uppercase">Comune</label>
            <ComuneSelect value={filters.comune} onChange={(v) => setFilters({ ...filters, comune: v })} provincia={filters.provincia || null} testid="filter-comune" placeholder="Cerca…" />
          </div>
          <div>
            <label className="label-uppercase">Agenzia</label>
            <select value={filters.agency_id} onChange={upd("agency_id")} className="admin-input" data-testid="filter-agency">
              <option value="">Tutte</option>
              {agencies.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
            </select>
          </div>
          <div>
            <label className="label-uppercase">Criterio</label>
            <select value={filters.criterio} onChange={upd("criterio")} className="admin-input" data-testid="filter-criterio">
              <option value="">Tutti</option>
              {Object.entries(CRITERI).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
          <div>
            <label className="label-uppercase">Da</label>
            <input type="date" value={filters.from_date} onChange={upd("from_date")} className="admin-input" />
          </div>
          <div>
            <label className="label-uppercase">A</label>
            <input type="date" value={filters.to_date} onChange={upd("to_date")} className="admin-input" />
          </div>
        </div>
        <div className="flex justify-between items-center mt-4">
          <button onClick={resetFilters} className="text-xs label-uppercase text-[#5C5657] hover:text-[#7D2E3F]">Reset filtri</button>
          <div className="flex gap-3">
            <button onClick={exportCSV} data-testid="export-csv" className="btn-secondary text-sm">Esporta CSV</button>
            <button
              onClick={() => setPdfModal(true)}
              data-testid="export-pdf"
              disabled={!filters.provincia && !filters.comune}
              className="btn-primary text-sm disabled:opacity-40 disabled:cursor-not-allowed"
              title={(!filters.provincia && !filters.comune) ? "Filtra prima per provincia o comune" : ""}
            >
              Esporta PDF opponibile
            </button>
          </div>
        </div>
      </div>

      <div className="admin-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F4F3F1]">
            <tr>
              <th className="text-left px-4 py-3 label-uppercase">Arrivo lead</th>
              <th className="text-left px-4 py-3 label-uppercase">Inoltro</th>
              <th className="text-left px-4 py-3 label-uppercase">Venditore</th>
              <th className="text-left px-4 py-3 label-uppercase">Zona</th>
              <th className="text-left px-4 py-3 label-uppercase">Agenzia</th>
              <th className="text-left px-4 py-3 label-uppercase">Criterio</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`assignment-${r.id}`} className="border-t border-[#E6E4E0]">
                <td className="px-4 py-3 text-xs text-[#5C5657]">{fmtDT(r.lead_arrivo_at)}</td>
                <td className="px-4 py-3 text-xs">{fmtDT(r.inoltrato_at)}</td>
                <td className="px-4 py-3">
                  <div className="text-[#3A3D42]">{r.lead_nome}</div>
                  <div className="text-xs text-[#8A8484]">{r.lead_email} · {r.lead_telefono}</div>
                </td>
                <td className="px-4 py-3">{r.comune || "—"} <span className="text-xs text-[#8A8484]">({r.provincia || "—"})</span></td>
                <td className="px-4 py-3">{r.agency_name || "—"}</td>
                <td className="px-4 py-3"><span className="badge-stamp badge-pronto text-[10px]">{CRITERI[r.criterio] || r.criterio}</span></td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={6} className="text-center py-16 text-[#5C5657]">Nessun inoltro registrato con questi filtri</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {pdfModal && (
        <div className="fixed inset-0 z-50 bg-[#3A3D42]/60 flex items-start justify-center overflow-auto p-4" data-testid="pdf-modal">
          <div className="bg-white border border-[#E6E4E0] w-full max-w-xl mt-16 mb-16">
            <div className="p-8">
              <div className="flex justify-between items-start">
                <div>
                  <div className="label-uppercase text-[#7D2E3F]">Registro opponibile</div>
                  <h2 className="font-serif text-3xl mt-2 leading-tight">Esporta PDF per zona</h2>
                </div>
                <button onClick={() => { setPdfModal(false); setPdfDest(""); }} className="text-[#5C5657] text-xl">×</button>
              </div>
              <p className="text-sm text-[#5C5657] mt-4 leading-relaxed">
                Il PDF elenca in ordine cronologico <strong>tutti i lead della zona selezionata</strong>,
                con data di arrivo, data di inoltro, agenzia assegnata e criterio. Se scegli un destinatario,
                per quell'agenzia i dati del venditore appaiono in chiaro; gli altri record sono
                anonimizzati come <em>Lead #ID</em>, mantenendo visibili le informazioni necessarie a
                dimostrare l'equità della distribuzione.
              </p>
              <div className="mt-6 border border-[#E6E4E0] bg-[#FBFAF7] p-4 text-sm space-y-1">
                <div><span className="label-uppercase text-[10px] text-[#5C5657]">Provincia </span><strong>{filters.provincia || "—"}</strong></div>
                <div><span className="label-uppercase text-[10px] text-[#5C5657]">Comune </span><strong>{filters.comune || "Tutti"}</strong></div>
                <div><span className="label-uppercase text-[10px] text-[#5C5657]">Periodo </span><strong>{(filters.from_date || filters.to_date) ? `${filters.from_date || "—"} → ${filters.to_date || "—"}` : "Tutti i periodi"}</strong></div>
              </div>
              <div className="mt-6">
                <label className="label-uppercase">Destinatario del registro (opzionale)</label>
                <select value={pdfDest} onChange={(e) => setPdfDest(e.target.value)} className="admin-input" data-testid="pdf-destinatario">
                  <option value="">— Registro anonimo (tutti i lead anonimizzati) —</option>
                  {agencies.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                </select>
                <p className="text-xs text-[#8A8484] mt-2 leading-relaxed">
                  Se scegli un'agenzia: nel PDF i suoi lead avranno nome + contatti in chiaro, gli altri restano anonimi.
                  Se non scegli nessuno: tutti i lead sono anonimi (registro pubblico di trasparenza).
                </p>
              </div>
              <div className="pt-6 mt-6 border-t border-[#E6E4E0] flex justify-end gap-3">
                <button onClick={() => { setPdfModal(false); setPdfDest(""); }} className="btn-secondary">Annulla</button>
                <button onClick={exportPDF} disabled={pdfLoading} data-testid="pdf-generate" className="btn-primary">
                  {pdfLoading ? "Generazione…" : "Genera e scarica PDF"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
